
import * as sagas from "./product.sagas";
import * as reducers from "./product.reducers";

export { sagas, reducers };